import { render, staticRenderFns } from "./BottomDrawer.vue?vue&type=template&id=bfe9d168&"
import script from "./BottomDrawer.vue?vue&type=script&lang=js&"
export * from "./BottomDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports